/* src/app/app.component.scss */
.spinner-class {
  position: unset !important;
}
/*# sourceMappingURL=app.component-32D6GLTV.css.map */
